import React from 'react';
import { Menu, Icon, Dropdown, Button, Avatar,Row, Col } from 'antd';
import {StyleHeader,DivUser,TituloEmpresa} from './style'
import ava from '../../assets/images/avatar.jpg'


const styleIconButton = {
    fontSize: '23px',
    padding: '22px',
    color: '#3261fb',
    cursor: 'pointer'
}
const styleMenu = {
    height: '200px',
    width: '400px',
    padding: '5px',
    display: 'flex',
    flexDirection:"column",
    justifyContent:"center",
}
 
const HeaderLayout = ({usuario, logout}) => {
    if(usuario){
        return ( 
            <StyleHeader>
            <Row type="flex" justify="space-around" align="middle">
                <Col lg={12} md={6} sm={12} xs={24}>
                    <TituloEmpresa>Nacional Ferretera de Hidalgo </TituloEmpresa>
                </Col>
                <Col lg={12} md={6} sm={12} xs={24} >
                    <DivUser>
                    <Avatar size={50} src={ava} />
                        {/* {usuario.profile_user.foto? <Avatar size={64} src={usuario.profile_user.foto} />:<Avatar size={64} icon="user" />} */}
                            <Dropdown overlay={
                                <Menu theme="light" style={styleMenu}>
                                    <p><strong>Nombre: </strong>{usuario.first_name.toUpperCase()} {usuario.last_name.toUpperCase()}</p>
                                    <p><strong>Usuario: </strong> {usuario.username} </p>
                                    <div style={{display:"flex", justifyContent:"center"}}>
                                        <Button type={"primary"}  onClick={logout}>Cerrar sesion</Button>
                                    </div>
                                </Menu>
                            }  trigger={['click']}>
                            <Icon type="down" style={styleIconButton} />
                        </Dropdown>
                    </DivUser>
                </Col>
            </Row>
        </StyleHeader>
        );
    }
    else
    {
        return(
            <StyleHeader>
                <Row type="flex" justify="space-around" align="middle">
                    <Col lg={12} md={6} sm={12} xs={24}  >
                        <TituloEmpresa>NACIONAL FERRETERA DE HIDALGO </TituloEmpresa>
                    </Col>
                    <Col lg={12} md={6} sm={12} xs={24} >
                        <DivUser>
                            <Dropdown overlay={
                                <Menu theme="light" style={styleMenu}>
                           
                                    <p>teléfono</p>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <Button onClick={logout}>Cerrar sesion</Button>
                                    </div>
                                </Menu>
                            } trigger={['click']}>
                                <Icon type="down" style={styleIconButton} />
                            </Dropdown>
                        </DivUser>
                    </Col>
                </Row>
            </StyleHeader>
        )
    }
  
};

export default HeaderLayout;


